<template>
  <div class="form-table">
    <!-- 表单 -->
    <el-form ref="elForm" :model="formData" inline label-width="auto">
      <el-form-item label="客户姓名" prop="customerName">
        <el-input v-model="formData.customerName" placeholder="请输入" clearable></el-input>
      </el-form-item>
      <el-form-item label="销售人员" prop="salesPerson">
        <el-input v-model="formData.salesPerson" placeholder="请输入" clearable></el-input>
      </el-form-item>
      <el-form-item label="手机号" prop="phoneNumber">
        <el-input v-model="formData.phoneNumber" placeholder="请输入" clearable></el-input>
      </el-form-item>
      <el-form-item label="渠道" prop="decorationType">
        <el-select v-model="formData.decorationType" placeholder="请选择" clearable>
          <el-option
            v-for="(item, index) in channels"
            :key="index"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" :loading="loading" @click="handleSubmitForm">查询</el-button>
        <el-button :loading="loading" @click="handleResetForm">重置</el-button>
      </el-form-item>

      <div class="form-buttons">
        <el-button type="primary" :loading="exportLoading" @click="handleExport">导出</el-button>
      </div>
    </el-form>

    <!-- 表格 -->
    <el-table v-loading="loading" class="table" :data="tableData" height="100%" border stripe>
      <el-table-column type="index" label="序号" align="center" width="50"></el-table-column>
      <el-table-column prop="customerName" label="客户姓名" align="center"></el-table-column>
      <el-table-column prop="companyName" label="公司名称" align="center"></el-table-column>
      <el-table-column prop="phoneNumber" label="手机号" align="center"></el-table-column>
      <el-table-column prop="channel" label="渠道" align="center"></el-table-column>
      <el-table-column prop="nikeName" label="销售人员" align="center"></el-table-column>
      <el-table-column
        prop="productFirstCategory"
        label="商品一级类目"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="productSecondCategory"
        label="商品二级类目"
        align="center"
      ></el-table-column>
      <el-table-column prop="createTime" label="定制时间" align="center"></el-table-column>
      <el-table-column label="操作" align="center" width="80">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="handleRowEdit(scope)">
            查看
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页 -->
    <div class="table-page">
      <el-pagination
        :current-page="pageData.pageNum"
        :page-size="pageData.pageSize"
        :total="total"
        :page-sizes="[20, 50, 100, 200]"
        :disabled="loading"
        background
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      >
      </el-pagination>
    </div>

    <!-- 弹窗 -->
    <form-dlg v-model="showDlg" :data="currentRowData" @submit-form="dlgSubForm"></form-dlg>
  </div>
</template>

<script>
import FormDlg from './components/form-dlg.vue'
import { channel_config, getDZList, download_file } from '@/api'

export default {
  name: 'form-table',
  components: {
    FormDlg,
  },
  props: {},
  data() {
    return {
      loading: false,
      exportLoading: false,
      showDlg: false,
      formData: {},
      tableData: [],
      channels: [],
      currentRowData: {},
      pageData: {
        pageNum: 1,
        pageSize: 50,
      },
      total: 0,
    }
  },
  computed: {},
  watch: {},
  created() {
    this.channel_config()
    this.getTableData()
  },
  mounted() {},
  beforeDestroy() {},
  methods: {
    // 表单查询
    handleSubmitForm() {
      this.getTableData(1)
    },

    // 重置表单
    handleResetForm() {
      this.$refs.elForm.resetFields()
      this.getTableData(1)
    },

    // 导出
    handleExport() {
      this.exportLoading = true
      download_file({
        ...this.formData,
        ...this.pageData,
        pageSize: 9999,
      })
        .then(res => {
          const blob = new Blob([res.data], { type: res.headers['content-type'] })

          const disposition = res.headers['content-disposition']
          let filename = 'exported_file'

          if (disposition && disposition.includes('filename=')) {
            const match = disposition.match(/filename="?(.+?)"?$/)
            if (match) {
              filename = decodeURIComponent(match[1])
            }
          }

          const link = document.createElement('a')
          link.href = URL.createObjectURL(blob)
          link.download = filename
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)
          URL.revokeObjectURL(link.href)
        })
        .finally(() => {
          this.exportLoading = false
        })
    },

    // 表格行-编辑
    handleRowEdit(data) {
      const { row } = data

      this.currentRowData = { ...row }
      this.showDlg = true
    },

    // 表格行-删除
    handleRowDel(data) {
      const { row } = data

      this.currentRowData = { ...row }
      this.$message.success('删除成功')

      this.getTableData()
    },

    // 分页-改变页码大小
    handleSizeChange(pageSize) {
      this.pageData.pageSize = pageSize

      this.getTableData(1)
    },

    // 分页-改变当前页
    handleCurrentChange(pageNum) {
      this.getTableData(pageNum)
    },

    // 弹窗表单提交
    dlgSubForm() {
      if (this.currentRowData.id || this.currentRowData.id === 0) {
        this.getTableData()
      } else {
        this.getTableData(1)
      }
    },

    channel_config() {
      channel_config().then(res => {
        this.channels = (res || []).map(item => {
          return {
            label: item,
            value: item,
          }
        })
      })
    },

    // 获取表格数据
    getTableData(pageNum) {
      this.loading = true
      pageNum && (this.pageData.pageNum = pageNum)

      getDZList({
        ...this.formData,
        ...this.pageData,
      })
        .then(res => {
          const { records = [], total } = res || {}

          this.tableData = records
          this.total = total
        })
        .finally(() => {
          this.loading = false
        })
    },
  },
}
</script>

<style lang="less" scoped></style>
